import axios from "axios";

// Fallback URL por si la variable de entorno no está definida
const defaultApiUrl = 'https://backend-production-2aba.up.railway.app/api';

// Obtener la URL de la variable de entorno
let apiUrl = process.env.REACT_APP_API_URL || defaultApiUrl;

// Asegurarse de que la URL tenga el protocolo (https://)
if (apiUrl && !apiUrl.startsWith('http')) {
  apiUrl = `https://${apiUrl}`;
}

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle expired tokens and authentication errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si el error es 401 (No autorizado o token expirado)
    if (error.response && error.response.status === 401) {
      // Limpiar el localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      
      // Redirigir al login solo si no estamos ya en login o register
      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && currentPath !== '/register' && currentPath !== '/') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
